import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import * as fromInvoiceSetup from '../../../data-services/invoice/setup';
import * as fromShared from '../../../shared';
import { SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InvoiceComponent
    extends fromShared.EditGrid<fromInvoiceSetup.Invoice.InvoiceSetup>
    implements OnInit, OnDestroy, OnChanges
{
    public get numCols(): number {
        let ret = 22;
        if (!this.displayAddress) {
            ret -= 3;
        }
        if (!this.displayFooter) {
            ret -= 2;
        }
        return ret;
    }
    frozenCols = [{ field: 'EmployeeName', header: 'Person' }];
    cols = [
        // <!--  IDENTIFICATION GROUP -->
        { field: 'IsConsultant', header: 'Consultant?' },
        { field: 'AccountNumber', header: 'Account #' },
        { field: 'EUserID', header: 'User ID' },
        { field: '', header: 'Password' },
        { field: 'SupervisorName', header: 'Supervisor' },
        { field: 'WeekStartName', header: 'Week Start' },
        { field: 'DefaultServiceItemName', header: 'Default SI' },
        { field: 'DefaultPayrollItemName', header: 'Default PI' },
        { field: 'AuthorizedHolidays', header: 'Holiday Auths' },
        { field: 'LockDate', header: 'Lock out' },
        { field: 'Mobile_provider', header: 'Mobile Provider' },
        { field: 'Mobilewithprovider', header: 'Mobile #' },
        { field: 'SplitDayName', header: 'Split Day' },
        { field: 'ExpenseAllowed', header: 'Expense Entry' },
        { field: 'CreditCardName', header: 'Credit Card' },
        { field: 'EmailAddr', header: 'Email' },
        { field: 'Expectedhrsperday', header: 'Expected Hrs Per Day' },
        { field: 'Expectedhrsperweek', header: 'Expected Hrs Per Week' },
        { field: 'IsPartTime', header: 'Part Time?' },
        { field: 'EmpTimeZone', header: 'Time Zone' },
        { field: 'ReminderDeliveryName', header: 'Reminder Delivery' },
        { field: 'CostCenterName', header: 'Cost Center' },
        { field: 'PayrollFrequency', header: 'Unique Pay Cycle' },
        { field: 'Usertype', header: 'Usertype' },
        { field: 'HireDate', header: 'Hire Date' },
        { field: 'ReleaseDate', header: 'Release Date' }
    ];
    @Input() types: SelectItem[] = [];
    @Input() displayAddress: boolean;
    @Input() displayFooter: boolean;
    @Input() addresses: SelectItem[] = [];
    @Input() remitAddresses: SelectItem[] = [];
    @Input() billingAddresses: SelectItem[] = [];
    @Input() signatures: SelectItem[] = [];
    @Input() accountClassProperties: SelectItem[] = [];
    @Input() signatureLineProperties: SelectItem[] = [];
    @Input() invoiceViewOptions: SelectItem[] = [];
    @Input() disclaimerProperties: SelectItem[] = [];
    @Input() paymentTermsProperties: SelectItem[] = [];
    @Input() contracts: SelectItem[] = [];
    @Input() chargeNumbers: SelectItem[] = [];
    contractChargeOptions: SelectItem[] = [
        { label: 'Contract', value: 'contract' },
        { label: 'Charge Number', value: 'chargeNumber' }
    ];
    private active = true;

    IsColumnFrozen = false;

    @Output() PassElements = new ReplaySubject<HTMLCollectionOf<Element>>(1);

    elements: HTMLCollection;

    constructor(private log: LoggingService, private cdRef: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.elements = document.getElementsByClassName('p-header-cell');
            this.PassElements.next(this.elements);
        }, 0);
    }
    ngAfterViewInit(): void {
        this.IsColumnFrozen = true;
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (
            changes.items &&
            changes.items.currentValue &&
            changes.items.currentValue.length > 0
        ) {
            this.log.verbose({ type: 'InvoiceComponent:ngOnChanges', changes });
            this.selected = [];
        }
    }
    onRowEditInit(item: fromInvoiceSetup.Invoice.InvoiceSetup) {
        super.onRowEditInit(item);
        if (item.Invoicelevel?.toLocaleLowerCase() === 'contract') {
            this.contractChargeOptions = [
                { label: 'None', value: 'none' },
                { label: 'Contract', value: 'contract' }
            ];
        } else {
            this.contractChargeOptions = [
                { label: 'None', value: 'none' },
                { label: 'Contract', value: 'contract' },
                { label: 'Charge Number', value: 'chargeNumber' }
            ];
        }
    }
}
